export default {
  baseStyle: {
    dialogContainer: {
      textAlign: "center",
      color: "paleGrey.500",
      bg: "dullBrown.500",
    },
    dialog: {
      bg: "dullBrown.500",
      boxShadow: "none",
    },
    closeButton: {
      h: "90px",
      fontSize: "1.2rem",
      fontWeight: "semibold",
      textTransform: "uppercase",
      boxShadow: "none",
      _focus: {
        boxShadow: "none",
      },
    },
  },
}
